import { css } from '@emotion/react';
import { Link } from '@mui/material';
import { forceThemeProps, ScorencoLogo } from '@scorenco/components';
import { useTranslation } from '@scorenco/core';

import { T_KEYS } from '@/translations';

const style = {
  root: () => css`
    position: relative;
    text-align: center;
    background: white;
    width: 100%;
    padding: 0.65rem 0.5rem;
    margin: auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5rem;
    font-size: 0.75rem;

    .snc-logo {
      /* width: 8rem; */
      height: 1.25rem;
      position: absolute;
      left: 15px;
    }

    @media screen and (max-width: 886px) {
      flex-direction: column;
      .snc-logo {
        position: relative;
      }
    }
  `,
};

export const FooterScorenco = () => {
  const { t } = useTranslation();
  return (
    <Link
      {...forceThemeProps('light')}
      href="https://scorenco.com"
      target="_blank"
      className="footer"
      css={style.root}
    >
      <ScorencoLogo className="snc-logo" />
      {t(T_KEYS.SCORENCO_FOOTER)}
    </Link>
  );
};
